import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { NewsService } from '@millionshow/api-client';
import { Icon, SafeHtmlPipe } from '@millionshow/client-libs';
import { injectParams } from 'ngxtension/inject-params';
import { of } from 'rxjs';

@Component({
  selector: 'app-news-detail',
  imports: [CommonModule, RouterLink, Icon, SafeHtmlPipe],
  templateUrl: './news-detail.page.html',
})
export default class NewsDetailPage {
  private readonly newsService = inject<NewsService>(NewsService);

  readonly id = injectParams('id');

  $data = rxResource({
    params: () => ({ id: this.id() }),
    stream: ({ params }) =>
      params.id
        ? this.newsService.newsControllerFindByIdV1({ id: params.id })
        : of(null),
  });

  readonly data = computed(() => this.$data.value());

  $adjacentNews = rxResource({
    params: () => ({ id: this.id() }),
    stream: ({ params }) =>
      params.id
        ? this.newsService.newsControllerFindAdjacentV1({ id: params.id })
        : of(null),
  });

  prevNews = computed(() => this.$adjacentNews.value()?.prev ?? null);
  nextNews = computed(() => this.$adjacentNews.value()?.next ?? null);
}
